// eslint-disable-next-line arrow-body-style
export const isNotNullOrUndefined = <T>(input: null | undefined | T): input is T => {
	// NOTE: This is intended to be used with array `.filter(isNotNullOrUndefined)` to prevent TS linting errors
	// See discussion here: https://github.com/microsoft/TypeScript/issues/16069
	return input !== null && input !== undefined;
};
